var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filteredRows.length > 0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.filteredRows,"border":""}},[_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_c('el-table-column',{attrs:{"prop":"_id","label":"_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }